'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MaterialCircularProgress from '@mui/material/CircularProgress';
import { getFuelSize } from '../types/general';
const sizes = {
    small: {
        size: '1rem',
        thickness: 5
    },
    medium: {
        size: '2rem',
        thickness: 4
    },
    large: {
        size: '3rem',
        thickness: 3
    }
};
export const CircularProgress = React.forwardRef(({ size: currentSize = 'medium', variant = 'indeterminate', ...props }, ref) => {
    const size = getFuelSize(currentSize);
    return (_jsx(MaterialCircularProgress, { color: 'primary', ref: ref, size: sizes[size].size, thickness: sizes[size].thickness, variant: variant, ...props }));
});
CircularProgress.displayName = 'CircularProgress';
